import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function CarouselSlide({ testId, children, className }) {
    return (_jsx("div", { className: classNames('flex h-full flex-col', className), "data-testid": testId, children: children }));
}
